<template>
  <section class="container">
    <div class="management_top_box">
      <h4>New TSG</h4>
    </div>
    <div class="brick_box">
      <table class="mgt_tbl mgb_0">
        <tbody>
          <tr>
            <th>Error Code GP</th>
            <td>
              <input
                type="text"
                v-model="form.errorCodeGp"
                class="int_type01 mgt_seltype"
                style="width: 99.8%;"
                name="errorCodeGp"
                v-validate="'required'"
              />
            </td>
            <th>Error Code Vendor</th>
            <td>
              <input
                type="text"
                v-model="form.errorCodeVendor"
                class="int_type01 mgt_seltype"
                style="width: 99.8%;"
                name="errorCodeVendor"
              />
            </td>
          </tr>
          <tr>
            <th>File</th>
            <td colspan="4">
              <input
                type="text"
                class="int_type01 mgt_seltype"
                style="width:91.4%;"
                v-model="form.fileName"
                id=fileName
                @click="AC_fileClick"
                readonly
              />
              <input
                type="file"
                id="file"
                name="file"
                accept="pdf"
                @change="uploadFile($event)"
                style="display: none"
              />
              <button v-if="form.fileNodeRef" @click="deleteFile" class="searchBtn btn btn-secondary btn-sm m-1" style="font-size: 16px;">
              Delete
              </button>
              <button v-else @click="AC_fileClick" class="searchBtn btn btn-primary btn-sm m-1" style="font-size: 16px;">
              Select
              </button>
            </td>
          </tr>
           <tr>
            <th>{{ $t("product.language") }}</th>
            <td>
              <select
                v-model="form.langCode"
                class="int_type01 mgt_seltype"
                v-validate="'required'"
                style="width:50%;"
              >
                <option value="">--{{ $t("common.all") }}--</option>
                <option
                  v-for="(lang, index) in langList"
                  :key="index"
                  :value="lang.codeId"
                >
                  {{ lang.codeName }}
                </option>
              </select>
            </td>
            <th>Version</th>
            <td>
              <input
                type="text"
                v-model="form.version"
                class="int_type01 mgt_seltype"
                name="version"
                style="width:92%;"
                v-validate="'required'"
              />
            </td>
          </tr>
          <tr>
            <th>Controller Type</th>
            <td>
              <select
                v-model="form.controllerId"
                class="int_type01 mgt_seltype"
                v-validate="'required'"
                style="width:50%;"
                @change="getTpcdList($event)"
              >
                <option value="">--{{ $t("common.all") }}--</option>
                <option
                  v-for="(controller, index) in controllerList"
                  :key="index"
                  :value="controller.controllerId"
                >
                  {{ controller.controllerName }}
                </option>
              </select>
            </td>
            <th>Source TPCD</th>
            <td>
              <select
                v-model="form.tpcdId"
                class="int_type01 mgt_seltype"
                v-validate="'required'"
                style="width:50%;"
                @change="getTpcdName($event)"
              >
                <option value="">--{{ $t("common.all") }}--</option>
                <option
                  v-for="(tpcd, index) in tpcdList"
                  :key="index"
                  :value="tpcd.tpcdId"
                >
                  {{ tpcd.tpcdName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <th>Exhaust Certification</th>
            <td colspan="4">
              <div class="d-flex">
                <div>
                  <autocomplete
                    :source="certificationList"
                    input-class="autocomplete-input mgt_seltype exhaust-certi"
                    ref="autocomplete"
                    @selected="validateSelectionCerti"
                    @results="getInputValueCerti()"
                    placeholder="Search a Certification"
                  >
                  </autocomplete>
                </div>
                <div style="margin-left: 10px; margin-top: 5px">
                  <span>Selected Value : </span>
                </div>
                <div style="margin-left: 10px; margin-top: 5px">
                  <span 
                    v-for="(item, index) in form.certificationList" 
                    v-bind:key="index" 
                    @click="deleteCertification(index)" 
                    style="margin-right: 10px; cursor: pointer;" 
                    title="Click to delete">{{ item.name }}
                  </span>
                </div>
              </div>
              <!-- <select
                v-model="form.exhaustCertiId"
                class="int_type01 mgt_seltype"
                v-validate="'required'"
                style="width:50%;"
              >
                <option value="">--{{ $t("common.all") }}--</option>
                <option
                  v-for="(ex, index) in certificationList"
                  :key="index"
                  :value="ex.exhaustCertiId"
                >
                  {{ ex.exhaustCertiName }}
                </option>
              </select> -->
            </td>
           
          </tr>
          <tr>
            <th>Model Code</th>
            <td colspan="4">
              <div class="d-flex">
                <div>
                  <autocomplete
                    :source="modelCodeList"
                    input-class="autocomplete-input mgt_seltype model-code"
                    ref="autocomplete"
                    @selected="validateSelectionCode"
                    @results="getInputValueCode()"
                    placeholder="Search a Model"
                  >
                  </autocomplete>
                </div>
                <div>
                  <!-- <button
                    type="button"
                    class="tbl_add_bt"
                    style="height: 34px; width: 34px"
                    @click="addModelCode"
                  >
                    Add
                  </button> -->
                </div>
                <div style="margin-left: 10px; margin-top: 5px">
                  <span>Selected Value : </span>
                </div>
                <div style="margin-left: 10px; margin-top: 5px">
                  <span 
                    v-for="(item, index) in form.modelCodeList" 
                    v-bind:key="index" 
                    @click="deleteModelCode(index)" 
                    style="margin-right: 10px; cursor: pointer;" 
                    title="Click to delete">{{ item.name }}
                  </span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th>Model Name</th>
            <td colspan="4">
              <div class="d-flex">
                <div>
                  <autocomplete
                    :source="modelNameList"
                    input-class="autocomplete-input mgt_seltype model-name"
                    ref="autocomplete"
                    @selected="validateSelectionName"
                    @results="getInputValueName()"
                    placeholder="Search a Model"
                  >
                  </autocomplete>
                </div>
                <div>
                  <button
                    type="button"
                    class="tbl_add_bt"
                    style="height: 34px; width: 34px"
                    @click="addModelName"
                  >
                    Add
                  </button>
                </div>
                <div style="margin-left: 10px; margin-top: 5px">
                  <span>Selected Value : </span>
                </div>
                <div style="margin-left: 10px; margin-top: 5px">
                  <span 
                    v-for="(item, index) in form.modelNameList" 
                    v-bind:key="index" 
                    @click="deleteModel(index)" 
                    style="margin-right: 10px; cursor: pointer;" 
                    title="Click to delete">{{ item.name }}
                  </span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="mgt_option_bottom">
        <button @click="deleteTsg" class="btn btn-secondary m-2">
          {{ $t("common.delete") }}
        </button>
        <button @click="regist()" class="btn btn-primary">
          {{ $t("common.save") }}
        </button>
        <router-link
          to="/management/library/tsg"
          class="btn btn-outline-dark"
          style="margin-left: 10px"
          >{{ $t("common.list") }}</router-link
        >
      </div>
    </div>
  </section>
</template>

<script>
import $ from "jquery";
import router from "@/routes/index";
import Autocomplete from "vuejs-auto-complete";
import { getTsgForm, tsgUpdate, tsgDelete } from "@/api/tsg";
import { getMgmtTpcdList } from "@/api/tpcd";
export default {
  components: {
    Autocomplete,
  },
  data() {
    return {
      controllerList: [],
      tpcdList: [],
      langList: [],
      certificationList: [],
      form: {
        tsgId: "",
        controllerId : "",
        controllerName : "",
        tpcdId : "",
        tpcdName : "",
        exhaustCertiId: "",
        langCode: "",
        modelNameList: [],
        modelCodeList: [],
        certificationList: [],
        fileNodeRef : "",
        fileName : "",
        folderNodeRef : "",
        file : "",
        errorCodeGp : "",
        errorCodeVendor : "",
        version : ""
      },
      confirmYN: false,
      modelNameList: [],
      modelCodeList: [],
      tmpValue: "",
      tmpValue2: "",
      tmpValue3: "",
      newFiles: ""
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.form.tsgId = this.$route.params.tsgId;
        if(!this.form.tsgId) this.form.tsgId = "";
        const resp = await getTsgForm(this.form.tsgId);
        if(resp.data.tsg) this.form = resp.data.tsg;
        this.controllerList = resp.data.controllerList;
        this.tpcdList = resp.data.tpcdList;
        this.langList = resp.data.langList;
        this.certificationList = resp.data.certificationList;
        this.modelCodeList = resp.data.modelCodeList;
        this.modelNameList = resp.data.modelNameList;
      } catch (err) {
        console.log(err);
      }
    },
    async regist() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      // model list validate
      if(this.form.modelCodeList.length==0||this.form.modelNameList.length==0)return alert(this.$t("alert.plzCheckAllValues"));
      // file validate
      if(!this.form.file && !this.form.fileName && !this.form.fileNodeRef)return alert(this.$t("alert.plzCheckAllValues"));
      let loader = this.$loading.show({});
      try {
        this.confirmYN = confirm(this.$t("alert.save"));
        if (this.confirmYN) {
          const formData = new FormData();
          if(this.form.tsgId){
            formData.append("tsgId", this.form.tsgId);
          }
          formData.append("controllerId", this.form.controllerId);
          formData.append("controllerName", this.form.controllerName);
          formData.append("tpcdId", this.form.tpcdId);
          formData.append("tpcdName", this.form.tpcdName);
          // formData.append("exhaustCertiId", this.form.exhaustCertiId);
          formData.append("langCode", this.form.langCode);
          for(let i=0; i<this.form.certificationList.length;i++){
            formData.append("certificationList[" + i + "].id", this.form.certificationList[i].id);
            formData.append("certificationList[" + i + "].name", this.form.certificationList[i].name);
          }
          for(let i=0; i<this.form.modelNameList.length;i++){
            formData.append("modelNameList[" + i + "].id", this.form.modelNameList[i].name);
          }
          for(let i=0; i<this.form.modelCodeList.length;i++){
            formData.append("modelCodeList[" + i + "].id", this.form.modelCodeList[i].id);
          }
          if(this.form.errorCodeGp) formData.append("errorCodeGp", this.form.errorCodeGp);
          if(this.form.errorCodeVendor) formData.append("errorCodeVendor", this.form.errorCodeVendor);
          formData.append("version", this.form.version);
          if(this.form.file) formData.append("file", this.form.file);
          const resp = await tsgUpdate(formData);
          console.log(resp);
          if (resp.data.status) {
            alert(this.$t("alert.savedSuccessfully"));
            router.push({ name: 'mgmtTsgForm', params: { tsgId: resp.data.tsgId } });
            // router.push({ name: 'mgmtTsg'});
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        }
      } catch (err) {
        console.log(err);
      } finally{
        loader.hide();
      }
    },
    // -----------Model Name
    validateSelectionName(selection) {
      if (selection.display != null && !this.form.modelNameList.includes(selection.display)) {
        this.form.modelNameList.push({name : selection.display});
      }
    },
    // 현재 선택한 ModelName 값
    getInputValueName() {
      this.tmpValue = $(".model-name").val();
      // 양쪽 공백 제거
      this.tmpValue = this.tmpValue.trim();
    },
    deleteModel(index) {
      this.form.modelNameList.splice(index, 1);
    },
    addModelName() {
      // 빈값과 기존에 있는 값 검사
      console.log(this.modelNameList);
      for (let j in this.modelNameList) {
        if (this.modelNameList[j].name == this.tmpValue || this.tmpValue == "") {
          alert(this.$t("alert.pleaseCheckTheValue"));
          return;
        }
      }
      this.modelNameList.push({ id: this.modelNameList.length + 1, name: this.tmpValue });
      this.validateSelectionName({ display: this.tmpValue });
    },
    // --------------Model Code 
    // 현재 선택한 ModelCode 값
    getInputValueCode(){
      this.tmpValue2 = $(".model-code").val();
      // 양쪽 공백 제거
      this.tmpValue2 = this.tmpValue2.trim();
    },
    validateSelectionCode(selection){
      if (selection.display != null && !this.form.modelCodeList.includes(selection.display)) {
        this.form.modelCodeList.push({id: selection.value , name : selection.display});
      }
    },
    deleteModelCode(index){
      this.form.modelCodeList.splice(index, 1);
    },
    // ----------- Certificaiton
    // 현재 선택한 Cerfication 값
    getInputValueCerti(){
      this.tmpValue3 = $(".exhaust-certi").val();
      // 양쪽 공백 제거
      this.tmpValue3 = this.tmpValue3.trim();
    },
    validateSelectionCerti(selection){
      if (selection.display != null && !this.form.certificationList.includes(selection.display)) {
        this.form.certificationList.push({id: selection.value , name : selection.display});
      }
    },
    deleteCertification(index){
      this.form.certificationList.splice(index, 1);
    },
    // ----------------------------------
    async getTpcdList(e){
      let upperControllerId = e.target.value;
      let name = e.target.options[e.target.options.selectedIndex].text;
      const resp = await getMgmtTpcdList(upperControllerId);
      this.tpcdList = resp.data.tpcdList;
      this.form.controllerName = name;
    },
    getTpcdName(e){
      let name = e.target.options[e.target.options.selectedIndex].text;
      this.form.tpcdName = name;
    },
    uploadFile(event){
      let input = event.target;
      let tmp = input.files[0].name;
      let fileName = tmp.split(".");
      if(fileName[fileName.length-1]!="pdf"){
        alert(this.$t("alert.ThisIsNotAnAllowedFile"));
        return;
      }
      this.form.fileName = tmp;
      // $("#fileName").val(tmp);
      this.form.file = input.files[0];
    },
    AC_fileClick(){
      $("#file").click();
    },
    async deleteTsg(){
      let loader = this.$loading.show({});
      try {
        this.confirmYN = confirm(this.$t("alert.delete"));
        if (this.confirmYN) {
          console.log(this.form);
          const resp = await tsgDelete(this.form);
          if (resp.data.status) {
            alert(this.$t("alert.deleteSuccessfully"));
            router.push({ name: 'mgmtTsg'});
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        loader.hide();
      }
    },
    deleteFile(){
      this.confirmYN = confirm(this.$t("alert.delete"));
      if (this.confirmYN) {
        this.form.fileName="";
        this.form.fileNodeRef="";
        this.form.file="";
        this.newFiles="";
      }
    }
  },
};
</script>

<style scoped>
.mgt_tbl tbody tr th {
  width: 20%;
}
.mgt_option_bottom {
  border-bottom: 0px;
}
.autocomplete__box{
  width: 235px;
}
</style>
